import angular from 'angular';
import { MeurhAdmissoesDocumentacaoFormController } from './documentacao.form.controller';

export class MeurhAdmissoesDocumentacaoFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesDocumentacaoFormComponent';
	static controller = MeurhAdmissoesDocumentacaoFormController;
	static template = require('!!html-loader!./documentacao.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
